// extracted by mini-css-extract-plugin
export var bounce = "style-module--bounce--55ec8";
export var busyBounce = "style-module--busyBounce--31404";
export var dot = "style-module--dot--31c68";
export var dotBlueprint = "style-module--dotBlueprint--fe832";
export var dotBusy = "style-module--dotBusy--cee7c";
export var logo = "style-module--logo--2c283";